import { useStanQuery } from '.';
import { QUERY_KEYS } from '@/lib/constants';
import { fetchUserIntegrations } from '@/lib/api/user';
import { useMemo } from 'react';
import { debounce } from 'lodash';

export const useIntegrations = () => {
    const { data, isLoading, error, refetch } = useStanQuery({
        queryKey: [QUERY_KEYS.INTEGRATIONS],
        queryFn: fetchUserIntegrations,
        meta: { error: { sentryMessage: '[INTEGRATIONS] failed-to-fetch-integrations' } },
    });

    // add debounce to this call
    const refetchIntegrations = useMemo(() => debounce(refetch, 300), [refetch]);

    return { data, isLoading, error, refetchIntegrations };
};
